import { PropType } from "vue";
import Component from "vue-class-component";

import { FIELD_VALUE_UPDATED } from "../../events";
import { ReactiveVue } from "@skinsoft/reactive-vue";
import { AutoCompleteTextField2Modal } from '../auto-complete-text-field2-modal';

@Component({
    components: {
        sAutoCompleteTextField2Modal: AutoCompleteTextField2Modal,
    },
    props: {
        availableValues: {
            type: Array as PropType<String[]>,
            default: () => [],
        },
        value: {
            type: String,
        },
        placeholder: {
            type: String,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    template: require("./auto-complete-text-field2.html")
})
export class AutoCompleteTextField2 extends ReactiveVue {
    private availableValues: String[]
    private value: String
    private placeholder: String
    private readonly: Boolean

    FIELD_VALUE_UPDATED = FIELD_VALUE_UPDATED

    public $refs: {
        modal: AutoCompleteTextField2Modal,
    }

    private get valueCopy(): String {
        return this.value
    }

    private set valueCopy(newValue: String) {
        this.$emit(FIELD_VALUE_UPDATED, newValue)
    }

    private onValueFromModal(value: string) {
        this.valueCopy = value
    }

    private openModal() {
        if(!this.readonly) {
            this.$refs.modal.openModal()
        }
    }
}